export var DriversLicenseType;
(function (DriversLicenseType) {
    DriversLicenseType["AM"] = "AM";
    DriversLicenseType["A1"] = "A1";
    DriversLicenseType["A2"] = "A2";
    DriversLicenseType["A"] = "A";
    DriversLicenseType["B"] = "B";
    DriversLicenseType["BE"] = "BE";
    DriversLicenseType["C1"] = "C1";
    DriversLicenseType["C1E"] = "C1E";
    DriversLicenseType["C"] = "C";
    DriversLicenseType["CE"] = "CE";
    DriversLicenseType["D1"] = "D1";
    DriversLicenseType["D1E"] = "D1E";
    DriversLicenseType["D"] = "D";
    DriversLicenseType["DE"] = "DE";
})(DriversLicenseType || (DriversLicenseType = {}));
